import React from 'react';
import './style.scss';

interface ScrollContainerProps {
	children: React.ReactNode;
}

const ScrollContainer: React.FC<ScrollContainerProps> = ({ children }) => {
	return <div className="scroll-container">{children}</div>;
};

export default ScrollContainer;
